import { HStack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

const LogoListDesktop = () => (
  <HStack
    d={{ base: 'none', desktop: 'flex' }}
    spacing="auto"
    alignItems="center"
    px={500}
    flexWrap="wrap"
  >
    <StaticImage
      placeholder="blurred"
      src="../../../assets/images/state_farm_logo_1.png"
      alt="crawford-logo"
      height={24}
      width={175}
    />
    <StaticImage
      height={100}
      placeholder="blurred"
      objectFit="contain"
      src="../../../assets/images/logo_nationWide.png"
      alt="gaf logo"
    />
    <StaticImage
      placeholder="blurred"
      width={123}
      height={35}
      src="../../../assets/images/amfam_logo.png"
      alt="srs logo"
    />
    <StaticImage
      placeholder="blurred"
      width={162}
      height={38}
      src="../../../assets/images/travelers_vector_logo_red.png"
      alt="travelers logo"
    />
    <StaticImage
      placeholder="blurred"
      width={67}
      height={67}
      src="../../../assets/images/shelter_insurance.png"
      alt="owens corning logo"
    />
    <StaticImage
      placeholder="blurred"
      width={134}
      height={59}
      src="../../../assets/images/cincinatti_logo.png"
      alt="bacon roofing supply logo"
    />
  </HStack>
);

export default LogoListDesktop;
